/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Webgl_Initialization_FailedInputs */

const bn_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL সূচনা ব্যর্থ হয়েছে৷`)
};

const de_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die WebGL-Initialisierung ist fehlgeschlagen.`)
};

const el_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η προετοιμασία WebGL απέτυχε.`)
};

const en_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL initialization failed.`)
};

const es_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La inicialización de WebGL falló.`)
};

const fr_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l’initialisation WebGL.`)
};

const hi_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL आरंभीकरण विफल रहा.`)
};

const hu_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A WebGL inicializálása nem sikerült.`)
};

const id_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi WebGL gagal.`)
};

const it_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizializzazione WebGL non riuscita.`)
};

const ja_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGLの初期化に失敗しました。`)
};

const ko_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL 초기화에 실패했습니다.`)
};

const nl_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL-initialisatie is mislukt.`)
};

const pl_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicjalizacja WebGL nie powiodła się.`)
};

const pt_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A inicialização do WebGL falhou.`)
};

const ru_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инициализация WebGL не удалась.`)
};

const sv_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL-initiering misslyckades.`)
};

const tr_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL'nin başlatılması başarısız oldu.`)
};

const uk_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка ініціалізації WebGL.`)
};

const vi_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khởi tạo WebGL không thành công.`)
};

const zh_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL 初始化失败。`)
};

const zh_hant_error_webgl_initialization_failed = /** @type {(inputs: Error_Webgl_Initialization_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGL 初始化失敗。`)
};

/**
* | output |
* | --- |
* | "WebGL initialization failed." |
*
* @param {Error_Webgl_Initialization_FailedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const error_webgl_initialization_failed = /** @type {((inputs?: Error_Webgl_Initialization_FailedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Webgl_Initialization_FailedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_error_webgl_initialization_failed(inputs)
	if (locale === "de") return de_error_webgl_initialization_failed(inputs)
	if (locale === "el") return el_error_webgl_initialization_failed(inputs)
	if (locale === "en") return en_error_webgl_initialization_failed(inputs)
	if (locale === "es") return es_error_webgl_initialization_failed(inputs)
	if (locale === "fr") return fr_error_webgl_initialization_failed(inputs)
	if (locale === "hi") return hi_error_webgl_initialization_failed(inputs)
	if (locale === "hu") return hu_error_webgl_initialization_failed(inputs)
	if (locale === "id") return id_error_webgl_initialization_failed(inputs)
	if (locale === "it") return it_error_webgl_initialization_failed(inputs)
	if (locale === "ja") return ja_error_webgl_initialization_failed(inputs)
	if (locale === "ko") return ko_error_webgl_initialization_failed(inputs)
	if (locale === "nl") return nl_error_webgl_initialization_failed(inputs)
	if (locale === "pl") return pl_error_webgl_initialization_failed(inputs)
	if (locale === "pt") return pt_error_webgl_initialization_failed(inputs)
	if (locale === "ru") return ru_error_webgl_initialization_failed(inputs)
	if (locale === "sv") return sv_error_webgl_initialization_failed(inputs)
	if (locale === "tr") return tr_error_webgl_initialization_failed(inputs)
	if (locale === "uk") return uk_error_webgl_initialization_failed(inputs)
	if (locale === "vi") return vi_error_webgl_initialization_failed(inputs)
	if (locale === "zh") return zh_error_webgl_initialization_failed(inputs)
	return zh_hant_error_webgl_initialization_failed(inputs)
});